module.exports = __webpack_public_path__ + "img/u20.fe14a1b4.png";